import Drawer, {DrawerProps} from '@mui/material/Drawer';
import SwipeableDrawer, {SwipeableDrawerProps} from '@mui/material/SwipeableDrawer';

import {styled} from '@mui/material/styles';

export const CDrawer = styled(Drawer)<DrawerProps>(
  (/* { theme } */) => ({
  }),
);

export const CSwipeableDrawer = styled(SwipeableDrawer)<SwipeableDrawerProps>(
  (/* { theme } */) => ({
  }),
);
